export const BACK_BUTTON_LABELS = {
  ar: 'الرجوع',
  de:'Zurück',
  es:'Atrás',
  en:'Back',
  fr:'Retour',
  id:'Kembali',
  it:'Indietro',
  ja:'戻る',
  ko:'뒤로',
  nl:'Terug',
  pl:'Wstecz',
  pt:'Voltar',
  'pt-br':'Voltar',
  ru:'Назад',
  sv:'Tillbaka',
  th:'ย้อนกลับ',
  tr:'Geri',
  zh:'返回',
};

export const MORE_BUTTONS_LABELS = {
  'ar': 'المزيد',
  'fr': 'Plus',
  'en': 'More',
  'es': 'Más',
  'de': 'Mehr',
  'id': 'Ekstra',
  'it': 'Più',
  'ja': '追加で',
  'ko': '더보기',
  'nl': 'Meer',
  'pl': 'Więcej',
  'pt': 'Mais',
  'pt-br': 'Mais',
  'ru': 'больше',
  'sv': 'Viac',
  'th': 'อีก',
  'tr': 'Daha',
  'zh': '多一点'
};
export const BURGER_MENU_LABELS = {
  ar: 'القائمة',
  de: 'Menü',
  es: 'Menú',
  en: 'Menu',
  fr: 'Menu',
  id: 'Menu',
  it: 'Menu',
  ja: 'メニュー',
  ko: '메뉴',
  nl: 'Menu',
  pl: 'Menu',
  pt: 'Menu',
  'pt-br': 'Menu',
  ru: 'МЕНЮ',
  sv: 'Meny',
  th: 'เมนู',
  tr: 'Menü',
  zh: '菜单',
};

export const NAV_ARIA_LABELS = {
  ar: 'التصفح الرئيسي',
  de:'Hauptnavigation',
  es:'Navegación Principal',
  en:'Main navigation',
  fr:'Navigation principale',
  id:'Navigasi Utama',
  it:'Navigazione principale',
  ja:'メインナビゲーション',
  ko:'기본 탐색',
  nl:'Hoofdnavigatie',
  pl:'Główna nawigacja',
  pt:'Navegação principal',
  'pt-br':'Navegação principal',
  ru:'Главное меню',
  sv:'Huvudsaklig',
  th:'การนำทางหลัก',
  tr:'ana yönlendirici',
  zh:'主导航',
};

export const LINK_NEW_WINDOW = {
  ar: 'نافذة جديدة',
  de: 'neues Fenster',
  es: 'nueva ventana',
  en: 'new window',
  fr: 'nouvelle fenêtre',
  id: 'jendela baru',
  it: 'nuova finestra',
  ja: '新しいウインドー',
  ko: '새 창에서 열기',
  nl: 'nieuw venster',
  pl: 'nowe okno',
  pt: 'nova janela',
  'pt-br': 'nova janela',
  ru: 'новое окно',
  sv: 'nytt fönster',
  th: 'หน้าต่างใหม่',
  tr: 'yeni pencere',
  zh: '新窗口',
};
